// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail---YlK9T8QM"};